import { Loader2 } from "lucide-react";
import { cn } from "../../lib/utils";

export const Spinner = ({ className, label }: { className?: string; label?: string }) => (
  <Loader2
    className={cn("size-5 animate-spin text-subtle", className)}
    aria-label={label}
    aria-hidden={!label}
    role={label ? "status" : undefined}
  />
);

export const PageSpinner = ({ label = "Loading" }: { label?: string }) => (
  <div className="flex min-h-[40vh] items-center justify-center">
    <Spinner className="size-6" label={label} />
  </div>
);
